module.exports = __webpack_public_path__ + "Icono_Lumbar-Bco_126px.png";